import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueCryptojs from 'vue-cryptojs'
import VueDisqus from 'vue-disqus'
import VueMeta from 'vue-meta'

// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/css/style.css';

import { SeasonSelector } from './functions/SeasonSelector'

// Vue.use(SeasonSelector)

Vue.prototype.$SeasonSelector = SeasonSelector

Vue.use(VueCryptojs)
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.use(VueDisqus, {
  shortname: 'gprewind'
})

Vue.use(VueMeta)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
